import { Box, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CircularProgressWithLabel from "../component/CircularProgressWithLabel";
import CustomSelectField from "../../../../../components/customFields/CustomSelectField";
import {
  DashboardStudentExamData,
  getRealTestTestTypes,
} from "../../../Api/DashboardApi";
import Loader from "../../../../../../SAPPages/components/Loader/Loader";
import NoDataAvailabWithNoCardleScreen from "../../../../../components/screens/NoDataAvailabeWithNoCard";

export default function ModuleWiseReport({
  dashBoardData,
  loading,
  testTypeData,
}) {
  const redirectionLink1 = "/test-prep/performance/purchase-test";
  const handleRedirect = () => {
    localStorage.setItem("testDetails", JSON.stringify(testTypeData));
    window.open(redirectionLink1, "_blank");
  };

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6} md={7}>
          <Typography
            fontFamily="Inter"
            color="#161719"
            sx={{ fontWeight: 600, fontSize: "18px" }}
          >
            Module Wise Progress
          </Typography>
        </Grid>

        <Grid item xs={12}>
          {loading ? (
            <Loader text="Loading Performance Details..." height="30vh" />
          ) : !loading && dashBoardData?.length > 0 ? (
            <Grid
              container
              spacing={2}
              height="255px"
              sx={{
                overflowY: "auto",
                pr: 1, // padding to avoid content cut by scrollbar
                "&::-webkit-scrollbar": {
                  width: "6px",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#EEEEEE", // purple like your screenshot
                  borderRadius: "3px",
                },
                "&:hover::-webkit-scrollbar-thumb": {
                  backgroundColor: "#EEEEEE", // purple on hover
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f5f5f5",
                  borderRadius: "3px",
                },
              }}
            >
              {dashBoardData.map((mod) => {
                const percentage = (mod?.given / mod?.assigned) * 100;
                // Assigning wand colors based on the name includes condition
                let wandColor;
                let valueColor;
                let backgroundColor;
                let icon;

                // Check if the name includes a specific keyword
                if (mod.name.includes("Reading")) {
                  wandColor = "#DC9F52"; // Light brown/golden color
                  valueColor = "#89591D"; // Darker brown for value color
                  backgroundColor = "#F3CEB480";
                  icon = (
                    <img src="/newdashboard/performance/Group 1171284044.png" />
                  );
                } else if (mod.name.includes("Writing")) {
                  wandColor = "#4DAE92"; // Teal green color
                  valueColor = "#1A6B54"; // Darker green for value color
                  backgroundColor = "#D8EFE8";
                  icon = (
                    <img src="/newdashboard/performance/Group 1171284044 (3).png" />
                  );
                } else if (mod.name.includes("Listening")) {
                  wandColor = "#507BB9"; // Blue color
                  valueColor = "#285391"; // Darker blue for value color
                  backgroundColor = "#C2CFF0";
                  icon = (
                    <img src="/newdashboard/performance/Group 1171284044 (1).png" />
                  );
                } else if (mod.name.includes("Speaking")) {
                  wandColor = "#ED8363"; // Coral orange color
                  valueColor = "#B94825"; // Darker orange for value color
                  backgroundColor = "#FFE7DF";
                  icon = (
                    <img src="/newdashboard/performance/Group 1171284044 (5).png" />
                  );
                } else if (mod.name.includes("Mock")) {
                  wandColor = "#2EADF0"; // Light brown/golden color
                  valueColor = "#2EADF0"; // Darker brown for value color
                  backgroundColor = " #D9EEFF";
                  icon = (
                    <img src="/newdashboard/performance/Group 1171284044 (4).png" />
                  );
                } else if (mod.name.includes("Verbal")) {
                  wandColor = "#DC9F52"; // Light brown/golden color
                  valueColor = "#89591D"; // Darker brown for value color
                  backgroundColor = "#F3CEB480";
                  icon = (
                    <img src="/newdashboard/performance/Group 1171284044 (4).png" />
                  );
                } else if (mod.name.includes("Quantitative")) {
                  wandColor = "#DC9F52"; // Light brown/golden color
                  valueColor = "#89591D"; // Darker brown for value color
                  backgroundColor = "#F3CEB480";
                  icon = (
                    <img src="/newdashboard/performance/Group 1171284044 (4).png" />
                  );
                } else {
                  // Default color in case the name doesn't match any known case
                  wandColor = "#DC9F52"; // Light brown/golden color
                  valueColor = "#89591D"; // Darker brown for value color
                  backgroundColor = "#F3CEB480";
                  icon = (
                    <img src="/newdashboard/performance/Group 1171284044 (4).png" />
                  );
                }
                return (
                  <Grid item xs={12} sm={6} key={mod.title} mt={1}>
                    <Paper
                      variant="outlined"
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        p: 2,
                        borderRadius: 3,
                        // height: "100%",
                      }}
                    >
                      <Box>
                        <Box display="flex" alignItems="center" gap={1}>
                          <Box width={30}>{icon}</Box>
                          <Typography
                            fontFamily="Inter"
                            color="#252525"
                            sx={{ fontWeight: 600, fontSize: "15px" }}
                            gap={2}
                          >
                            {mod.name}
                          </Typography>
                        </Box>
                        <Typography
                          mt={1}
                          fontFamily="Inter"
                          color="#333333"
                          sx={{ fontWeight: 400, fontSize: "13px" }}
                        >
                          Correct Answer: {mod?.given}/{mod?.assigned}
                        </Typography>
                      </Box>
                      <CircularProgressWithLabel
                        value={percentage}
                        color={wandColor}
                        valueColor={valueColor}
                        backgroundColor={backgroundColor}
                      />
                    </Paper>
                  </Grid>
                );
              })}
            </Grid>
          ) : (
            <NoDataAvailabWithNoCardleScreen
              topImage={
                <img src="/newdashboard/performance/20769812_Sandy_Bus-25_Single-04 1 (1).png" />
              }
              //  text="No Test Type Purchased Yet"
              subText="Upgrade to access all question types, instant scoring, and real-time analytics."
              buttonName="Upgrade Now"
              // buttonIcon={
              //   <Icon icon="material-symbols:crown-rounded" />
              // }
              imageSize={120}
              showTopImage={true}
              redirectionLink={handleRedirect}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
}
